/* @flow weak */
import AlertDialog from 'components/AlertDialog.jsx';
import Coin from 'components/Coin.jsx';
import Image from 'components/Image.jsx';
import Glyph from 'components/Glyph.jsx';
import GroupCreateModal from 'groups/components/GroupCreateModal.jsx';
import linkStateWithStores from 'components/mixins/linkStateWithStores';
import schoolImage from 'assets/images/school-circle.svg';
import OrganizationActions from 'actions/OrganizationActions';
import OrganizationStore from 'stores/OrganizationStore';
import React from 'react';
import { mountModal } from 'lib/modal';
import getRedirectLocationAfterGroupCreation from 'utils/getRedirectLocationAfterGroupCreation';

import './styles/AdminVerificationModal.scss';

const AdminRejectedModal = React.createClass({
  propTypes: {
    onRequestHide: React.PropTypes.func.isRequired,
    orgId: React.PropTypes.number.isRequired,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  mixins: [
    linkStateWithStores([OrganizationStore]),
  ],

  getInitialState() {
    return this.getStateFromStores();
  },

  componentWillMount() {
    OrganizationActions.getOrLoadOrganization(this.props.orgId);
  },

  getStateFromStores() {
    const org = OrganizationStore.getOrganization(this.props.orgId);
    return {
      orgName: org ? org.getName() : null,
    };
  },

  handleGroupCreated(group) {
    this.context.router.push(getRedirectLocationAfterGroupCreation(group));
  },

  showCreateClassDialog() {
    mountModal(<GroupCreateModal onCreate={this.handleGroupCreated} />, this);
  },

  render() {
    if (!this.state.orgName) {
      return false;
    }

    const badgedSchoolImage = (
      <div className="AdminVerificationModal-school-image">
        <Image
          className="AdminVerificationModal-school-rejected"
          height="64" width="64" src={schoolImage}
        />
        <Coin className="AdminVerificationModal-badge" size="xlarge" color="lava">
          <Glyph name="close" color="white" size="xxsmall" solo />
        </Coin>
        <div className="AdminVerificationModal-badge-border" />
      </div>
    );

    return (
      <AlertDialog
        eventScreenName="AdminRejectedModal"
        className="AdminVerificationModal"
        headerImageComponent={badgedSchoolImage}
        title={`We couldn't verify you as an admin at ${this.state.orgName}`}
        subtext="You'll receive an email from us with more information."
        buttonText="Create a class"
        onOkay={this.showCreateClassDialog}
        onRequestHide={this.props.onRequestHide}
      />
    );
  },

});

export default AdminRejectedModal;



// WEBPACK FOOTER //
// ./src/admin/components/AdminRejectedModal.jsx